import {
  type ClassValue,
  clsx,
} from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const rejectUndefinedAndNull = <T>(
  item: T | undefined | null,
): item is T => item !== undefined && item !== null

export function isValidUrl(str: string): boolean {
  try {
    new URL(str)
    return true
  } catch (error) {
    return false
  }
}

export const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

export interface ApiError {
  data: {
    codeText: string
    message: string
  }
}

export const isApiError = (error: unknown): error is ApiError => {
  return (
    typeof error === 'object' &&
    error !== null &&
    'data' in error &&
    typeof error.data === 'object' &&
    error.data !== null &&
    'codeText' in error.data &&
    typeof error.data.codeText === 'string'
  )
}
